import React, { Component } from "react";
import { Route } from "react-router";
import { trackPage } from "web/core/analytics";

const withTrackPage = (title, trackPage) => (BaseComponent) => (props) =>
  [
    <TrackPage
      key="track"
      title={typeof title === "function" ? title(props) : title}
      trackPage={trackPage}
    />,
    <BaseComponent key="component" {...props} />,
  ];

class TrackPageAux extends Component {
  componentDidMount() {
    this.trackPage(null, this.props);
  }

  componentDidUpdate(prevProps) {
    this.trackPage(prevProps, this.props);
  }

  trackPage(prevProps, nextProps) {
    if (
      prevProps &&
      prevProps.location.pathname === nextProps.location.pathname
    ) {
      return;
    }

    const track = this.props.trackPage || trackPage;
    track(nextProps.title);
  }

  render() {
    return null;
  }
}

class TrackPage extends Component {
  render() {
    return (
      <Route
        render={({ location }) => (
          <TrackPageAux title={this.props.title} location={location} />
        )}
      />
    );
  }
}

export default withTrackPage;
export { TrackPage };
